import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Card, CardHeader } from "@heroui/react";
import ClimatisationSection from "../sections/climatisation-section";

const KlimatisatiePage = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Klimatisatie | Onderhoud | Yally</title>
        </Helmet>
      </HelmetProvider>

      <Card className="bg-white shadow-sm">
        <CardHeader className="block p-0">
          <ClimatisationSection />
        </CardHeader>
      </Card>
    </>
  );
};

export default KlimatisatiePage;
